module.exports = __webpack_public_path__ + "static/img/ex01.49d3d3a2.jpg";